import { render, staticRenderFns } from "./AudioTranscriptionRecorder.vue?vue&type=template&id=0152427a&scoped=true&"
import script from "./AudioTranscriptionRecorder.vue?vue&type=script&lang=js&"
export * from "./AudioTranscriptionRecorder.vue?vue&type=script&lang=js&"
import style0 from "./AudioTranscriptionRecorder.vue?vue&type=style&index=0&id=0152427a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0152427a",
  null
  
)

export default component.exports